<!--
 * @Desc: 问题单列表页面
 * @Author: hedahai
 * @Date: 2020-10-19 14:12:52
-->
<template>
  <div class="inventory" ref="inventory">
    <div class="section-header" id="top">
      <div class="verticalLine"></div>
      <div class="title">问题单</div>
      <div style="flex: 1"></div>
      <el-button
        v-if="memberType === 'MEDIATOR' && !isClosed"
        @click="exportQuestions"
        plain
        type="primary"
        style="border-radius: 4px"
        >导出问题单</el-button
      >
      <el-button
        type="primary"
        plain
        style="border-radius: 4px"
        @click="quickAnsnwerPutAway"
      >
        {{ isAllClosed ? "一键展开" : "一键收起" }}
      </el-button>
      <el-button
        type="primary"
        plain
        style="border-radius: 4px"
        v-if="memberType === 'MEDIATOR' && !isClosed"
        @click="batchImport()"
      >
        批量导入
      </el-button>
      <el-button
        type="primary"
        v-if="memberType === 'MEDIATOR' && !isClosed"
        @click="createQuestionClick"
        >新增问题</el-button
      >
    </div>
    <div class="content" id="content" @scroll="onListScroll($event)">
      <div
        class="question-view"
        v-for="(item, index) in questions"
        :key="index"
        :id="item.id"
      >
        <!-- 问题 -->
        <div class="question">
          <img class="icon" src="@/assets/casespace/question_icon.png" />
          <div class="title">
            {{ item.sort }}{{ item.sort ? "." : "" }}{{ item.questionContent }}
            <el-button type="text" @click="answersPutAwayClick(index)">
              {{ item.isClosed === true ? "展开" : "收起" }}
              <i
                :class="
                  item.isClosed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
                "
              ></i>
            </el-button>
          </div>
          <template v-if="memberType === 'MEDIATOR'">
            <template v-if="!isClosed">
              <el-button
                type="primary"
                v-if="item.lockStatus === 0"
                plain
                style="border-radius: 4px"
                size="small"
                @click="unlockOrSaveBtnDidClick(index)"
              >
                解锁
              </el-button>
              <el-button
                type="primary"
                plain
                style="border-radius: 4px"
                size="small"
                @click="del(item)"
              >
                删除
              </el-button>
            </template>
          </template>

          <template v-else>
            <el-button
              type="primary"
              plain
              v-if="item.userAnswerRes && item.userAnswerRes.submitStatus === 1"
              style="border-radius: 4px"
              size="small"
              @click="unlockOrSaveBtnDidClick(index)"
            >
              保存
            </el-button>
          </template>
        </div>
        <!-- 回答状态 -->
        <div class="answer-status">
          <!-- 申请人回答状态 -->
          <div class="litigant">
            <div class="title" v-if="item.questionType != 21">
              申请人回答状态：
            </div>
            <div class="members" v-if="item.questionType != 21">
              <el-tag
                :type="subitem.submitStatus === 2 ? 'success' : 'warning'"
                class="member"
                v-for="(subitem, index) in item.applicantAnswerResList"
                :key="index"
              >
                <i
                  :class="
                    subitem.submitStatus === 2
                      ? 'el-icon-success icon'
                      : 'el-icon-question icon'
                  "
                ></i>
                {{ meetingTypeEnum[subitem.userType] }} ({{ subitem.userName }})
                <div
                  class="el-icon-circle-close buttonDelete"
                  v-if="memberType === 'MEDIATOR'"
                  @click="delAns(subitem, item, index)"
                ></div>
              </el-tag>
            </div>
            <!-- 被申请人申请人 -->
            <div class="title">被申请人回答状态：</div>
            <div class="members">
              <el-tag
                :type="subitem.submitStatus === 2 ? 'success' : 'warning'"
                class="member"
                v-for="(subitem, index) in item.respondentAnswerResList"
                :key="index"
              >
                <i
                  :class="
                    subitem.submitStatus === 2
                      ? 'el-icon-success icon'
                      : 'el-icon-question icon'
                  "
                ></i>
                {{ meetingTypeEnum[subitem.userType] }} ({{ subitem.userName }})
                <div
                  class="el-icon-circle-close buttonDelete"
                  v-if="memberType === 'MEDIATOR'"
                  @click="delAns(subitem, item, index)"
                ></div>
              </el-tag>
            </div>
          </div>
        </div>
        <!-- 答案部分 -->
        <div v-if="!item.isClosed" class="answer-view">
          <template
            v-for="appRes in [
              item.applicantAnswerResList,
              item.respondentAnswerResList,
            ]"
          >
            <el-row v-for="answer in appRes" :key="answer.id">
              <el-card
                :style="
                  'margin-top:10px; width:' + mediatorAnswerCardWidth + 'px'
                "
                shadow="hover"
                v-if="item.userAnswerRes &&
                  answer.answerContent && answer.id !== item.userAnswerRes.id
                "
              >
                <div class="answer">
                  <div class="name-type" style="background: #e0eefe">
                    {{ meetingTypeEnum[answer.userType] }} ({{
                      answer.userName
                    }})
                  </div>
                  <div class="content">
                    {{ convertAnswerForMediator(answer.answerContent) }}
                  </div>
                </div>
              </el-card>
            </el-row>
          </template>
        </div>
        <!-- 身份不为调解员的时候显示答案 -->
        <div
          v-if="!item.isClosed && memberType !== 'MEDIATOR'"
          style="margin-top: 10px; position: relative"
        >
          <answer
            ref="answerForm"
            :questionType="item.questionType"
            v-if="item.userAnswerRes"
            :submitStatus="item.userAnswerRes.submitStatus"
            :answerContent="item.userAnswerRes.answerContent"
          ></answer>
          <div
            class="answerListCover"
            @click="coverClick"
            v-if="showCover"
          ></div>
        </div>
      </div>
      <!-- 一键提交按钮 -->
      <div
        style="align-self: center; margin-top: 20px"
        v-if="personType !== 'STAFF'"
      >
        <el-button
          type="primary"
          style="border-radius: 4px; width: 200px"
          v-if="!isClosed"
          @click="answersSubmit"
          >一键提交</el-button
        >
      </div>
    </div>

    <!-- 创建问题模板 -->
    <create-question
      v-if="showCreateQuestion"
      @createQuestionEvent="createQuestionSuccessHandler"
      @closeEvent="closeCreateQuestionEvent"
    ></create-question>
    <!-- 批量导入弹窗 -->
    <el-dialog
      :visible.sync="this.batchImportDiolog"
      title="上传问题单"
      width="576px"
      :before-close="closeDialog"
      center
      class="dialog_model"
    >
    <p class="dialog_line"></p>
      <div class="dialogContainer">
        <div class="dialogContent">选择文件：</div>
        <div class="uploadContent">
          <el-upload
            class="upload-demo"
            :action="actionUrl"
            :accept="acceptType"
            :on-success="successother"
            :on-remove="fileremove"
            :before-upload="handleBefore"
            multiple
            drag
            :headers="flk"
            :data="uploaddata"
            :file-list="filelist"
            :http-request="handleRequestRecord"
          >
            <div class="el-btn-upload" >
              <i class="el-icon-upload2"></i> 点击上传
            </div>
            <div class="warn">只能上传xls、xlsx文件，且不能超过10M</div>
            <div class="excelTemplate" @click.stop="downloadTemplate" >
            <i class="el-icon-download"></i>
            模板下载
          </div>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="confirm_ca" @click="closeDialog">取 消</el-button>
        <el-button class="confirm_re" type="primary"  @click="submitQuestion"
          >导 入</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  mediatorQuestionListApi,
  usersubmitAnswersApi,
  userSaveAnswerApi,
  mediatorUnlockQuestionApi,
  deleteQuestion,
  userCanAnswer,
  saveAllQuestionAnswer,
  cancleAnswer,
  getQuestionExcel
} from "@/api/question_list.js";
import { getDefalutQuestionListApi, submitQuestionsApi } from '@/api/question_list.js'
import answer from "./answer.vue";
import quesListVue from "../components/quesList.vue";
import config from "@/config/config.js";
import { setStore, getStore, isElementNotInViewport,maxFileLength } from "@/utils/utils.js";
import { UserRole } from "@/common/js/roleMixin.js";
import { Promise } from "q";
import { resolve } from "url";
import { downloadTemplate ,analysisExcel} from "@/api/case";
// import filedownload from '@/api/filedown.js'
import filedownload from '@/utils/filedown.js'

export default {
  mixins: [UserRole],
  data() {
    return {
    filelist:[],//上传模版问题列表
    questionList:[],//一键导入问题列表
      actionUrl: config.baseURL + "/gzzc/docBook/upload", //控制批量导入的内容
      acceptType: ".xls,.xlsx",
      uploaddata: {
        isView: "VIEW",
      },
      flk: {JWTToken: '', appName: 'gzzc',cType:'PC'},
      questions: [],
      // 最后陈述意见
      // finalStatements: [],
      isAllClosed: false,
      showCreateQuestion: false,
      // 当前用户在案件中的身份
      memberType: "",
      // 记录调解员答案el-card元素的宽度
      mediatorAnswerCardWidth: 500,
      wsLink: "",
      currentRoomId: "",
      isGuideDidClick2scroll: false, //点击小圆点滚动
      isClosed: localStorage.getItem("CloseState") == "true" ? true : false,
      hasEmoji: false,
      showCover: false,
      hasSpeChar: false,
      personType: '',
      batchImportDiolog: false,
    };
  },
  props: {
    data: Array,
  },
  watch: {
    data(value) {
      if (this.memberType === "MEDIATOR") {
        for (let index = 0; index < value.length; index++) {
          const element = value[index];
          // 拼接一个不存在的id以适配tempalate判断逻辑
          element.userAnswerRes = {
            id: -1,
          };
        }
      }
      this.questions = value;
      this.$forceUpdate();
      this.$nextTick(function () {
     this.checkAnswerStatus();
      });
    },
  },
  components: {
    answer,
    createQuestion: (resolve) => require(["./createQuestion.vue"], resolve),
  },
  created() {
    let loginInfo = JSON.parse(getStore("loginInfo"));
    this.personType = loginInfo.personType
    if (loginInfo.personType === "STAFF") {
      this.memberType = loginInfo.userRoles[0].roleCode;
      if (this.memberType === 'CLERK') {
        this.memberType = 'MEDIATOR'
      }
    } else {
      this.memberType = loginInfo.memberType;
    }
    setStore("hasSubmitQuesListSuccessFlag", true);
  },
  mounted() {
    let that = this;
    that.$nextTick(function () {
      that.mediatorAnswerCardWidth = that.$refs.inventory.clientWidth - 80;
    });
    let wsInfo = this.$store.getters.getWSLink;
    if (wsInfo.hasOwnProperty("wsLink")) {
      this.wsLink = wsInfo.wsLink;
      this.currentRoomId = wsInfo.currentRoomId;
    } else {
      let currentRoomId =
        this.$route.query.roomid.indexOf(",") != -1
          ? this.$route.query.roomid.split(",")[0]
          : this.$route.query.roomid;
      this.$store
        .dispatch("initWSLink", {
          currentRoomId: currentRoomId,
        })
        .then((res) => {
          this.wsLink = res;
          this.currentRoomId = currentRoomId;
        });
    }
    userCanAnswer({
      mediationId: this.$route.query.meetingid,
    })
      .then((res) => {
        console.log("当事人是否能回答----", res.data.data, res.data);
        this.showCover = !res.data.data;
      })
      .catch((err) => {
        console.log("当事人是否能回答----", err);
      });
  },
  methods: {
    handleRequestRecord(file){
        console.log(this.filelist,file)
        let params = new FormData()
        params.append('uploadExcel', file.file)
        console.log(params)
        analysisExcel(params).then(res=> {
            console.log(res)
            // questionList
            if (res.data.code === 1000) {
                    let resData = res.data.data
                    if (resData && resData.length) {
                        resData.forEach(item => {
                            this.questionList.push({ text: item.questionContent, sort: item.sort })
                        })
                     console.log(this.questionList)
                    }
                } else if (res.data.message) {
                    this.$message.error(res.data.message)
             }

         })


    },
    submitQuestion(){
      //questionType
      console.log(this.questionList)
      let list = []
      this.questionList.map(i=>{
         // return i.questionType = 0
          list.push({
          questionType:  0,
          questionContent: i.text,
          sort:i.sort
        })
      })
      if(list.length> 0 ){
      let params = {
        mediationId: this.$route.query.meetingid,
        questionList: list
      }
      submitQuestionsApi(params).then(res => {
         console.log(res)
        if(res.data.code === 1000){
          this.closeDialog()
          // this.filelist = []
          this.$message.success('导入成功')
          this.$emit('createQuestionEvent')
          this.$emit("reloadData");
          this.questionList = []
        }else{ 
          this.$message.error(res.data.message)
        }
      })
      }else{
         this.$message.warning('问题序号不能为空')
      }
    },
    // 模板下载
    downloadTemplate() {
      console.log("我是模板下载");
      filedownload("/gzzc/docBook/clerkRecordDownload",{
            fileId: 'Z3p6Y180OWRjMjdmMTMwNTg0NTAwOTUxYmM5YmQ4MDRkNmJhNw==.xlsx&',
            id: 57421
       },"template.xlsx")
    },
    closeDialog() {
       this.batchImportDiolog = false;
       this.questionList = []
       this.filelist = []
    },
    // 批量导入上传之前的回调
    handleBefore(file,accept) {
    //   console.log("批量导入上传之前的回调");
       if (file.size > maxFileLength) {
                this.$message({
                    type: 'warning',
                    message: maxFileWarning
                });
                return false
            }
            let tempRet = /\.[^.]+$/.exec(file.name)
            let isAcceptType = true
            // if (tempRet) {
            //     if (!~accept.indexOf(tempRet[0])) {
            //         isAcceptType = false
            //     }
            // }
            if (!isAcceptType) {
                this.$message({
                    type: 'warning',
                    message: '文件只支持' + accept + '等格式'
                });
                fileList.pop()
                return false
            }
            this.flk.JWTToken = getStore('flk');
    },
    // 批量上传移除的回调
    fileremove(index) {
        console.log("批量上传移除的回调");
    },
    //批量导入成功的回调
    successother(res,file,fileList) {
      console.log(res ,this.filelist)
         if (res.code === 1000) {
              this.filelist = fileList
         }
         console.log(res)
    },
    //批量导入
    batchImport() {
      this.batchImportDiolog = true;
      this.questionList = []
    },
    //导出问题单
    exportQuestions(){
      const meetingId = this.$route.query.meetingid
      filedownload("/scavenger/question/getQuestionExcel",{
            meetingId
       },"问题单.xlsx")
    },
    del(val) {
      console.log("删除", val);
      let params = {
        questionId: val.id,
        mediationId: val.mediationId,
      };
      if (this.memberType === "MEDIATOR") {
        this.$confirm("此操作将永久删除该问题, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deleteQuestion(params)
              .then((res) => {
                if (res.data.code == 1000) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.$emit("reloadData");
                  this.questionList = []
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                // this.$message.error(err.message)
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    delAns(subItem, item, index) {
      console.log("点击了x---", subItem, item, index);
      if (subItem.submitStatus == 2) {
        this.$message.error("该用户已经回答,禁止操作!");
        return;
      }
      let params = {
        mediationId: this.$route.query.meetingid,
        questionId: item.id,
        userId: subItem.userId,
      };
      this.$confirm("此操作将禁止当前用户回答该问题, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        cancleAnswer(params)
          .then((res) => {
            if (res.data.code === 1000) {
              console.log("成功----");
              this.$emit("reloadData");
            }
          })
          .catch((err) => {
            console.log("一键保存err----", err);
          });
      });
    },
    // 创建问题成功的回调
    createQuestionSuccessHandler() {
      //获取子组件发送文书回调参数
      let data = {
        roomId: this.currentRoomId,
        messageType: "QUESTION_SHEET",
        categoryBig: "", //非必填
        messageResource: "HANDLER_INPUT",
        content: JSON.stringify({
          questionText: "", //小程序签名使用
        }),
      };
      let msgdata = {};
      msgdata.event = "SEND_MESSAGE";
      msgdata.data = data;
      console.log("发送", msgdata);
      this.wsLink.send(JSON.stringify(msgdata));
      this.$emit("reloadData");
    },
    // 答案收回，展开按钮
    answersPutAwayClick(index) {
      console.log("answersPutAwayClick", index);
      let questions = this.questions;
      questions[index].isClosed = !questions[index].isClosed;
      this.questions = questions;
      // console.log(this.questions)
      // 检查所有问题的展开状态
      let flag = false;
      this.questions.map((item) => {
        if (item.isClosed !== this.questions[0]) {
          flag = true;
        }
      });
      if (flag) {
        if (this.questions[0].isClosed) {
          this.isAllClosed = true;
        } else {
          this.isAllClosed = false;
        }
      }
      this.$forceUpdate();
    },
    // 一键展开，一键收回 点击事件
    quickAnsnwerPutAway() {
      this.isAllClosed = !this.isAllClosed;
      this.questions.map((item) => {
        if (this.isAllClosed) {
          item.isClosed = true;
        } else {
          item.isClosed = false;
        }
      });
    },
    checkAnswerStatus() {
      let status = true;
      if (this.questions && this.questions.length) {
        this.questions.map((item) => {
          if (item.userAnswerRes && item.userAnswerRes.submitStatus !== 2) {
            status = false;
          }
        });
      }
      setStore("hasSubmitQuesListSuccessFlag", status);
    },
    // 新增问题1
    createQuestionClick() {
      this.showCreateQuestion = false;
      this.showCreateQuestion = true;
    },
    // 关闭新增问题对话框事件回调
    closeCreateQuestionEvent() {
      this.showCreateQuestion = false;
    },
    // 解锁按钮 保存按钮的点击事件
    unlockOrSaveBtnDidClick(index) {
      if (this.memberType === "MEDIATOR") {
        let params = {
          questionId: this.questions[index].id,
          mediationId: this.$route.query.meetingid,
        };
        mediatorUnlockQuestionApi(params)
          .then((res) => {
            // 解锁成功
            // this.questions[index].lockStatus = 0
            this.$emit("reloadData");
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      } else {
        // 保存按钮的点击事件
        if (this.showCover) {
          this.$message({
            type: "error",
            message: "申请人未回答完毕",
          });
          return;
        }
        this.$refs.answerForm[index].getCurrentForm().then((answerJsonStr) => {
          console.log(this.$refs.answerForm[index].getCurrentForm());
          let params = {
            questionId: this.questions[index].id,
            mediationId: this.$route.query.meetingid,
            answerContent: answerJsonStr,
          };
          console.log("11111", params);
          userSaveAnswerApi(params)
            .then((res) => {
              if (res.data.code == 1003) {
                this.$message.warning(res.data.message);
                return;
              } else {
                console.log(res);
                this.$message.success("保存已生效");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        });
      }
    },
    // 所有答案的保存事件
    answersSubmit() {
      // 校验所有的答案,如果有一个答案不符合规范，那么暂停提交
      // 遍历问题集合，逐个调用子组件getCurrentForm方法
      let that = this;
      that.hasEmoji = false;
      that.hasSpeChar = false;
      this.checkAnswerCorrect()
        .then((res) => {
          console.log(res);
          if (res.flag) {
            if (that.hasEmoji) {
              this.$message({
                type: "error",
                message: "系统暂不支持emoji表情",
              });
              return;
            }
            if (that.hasSpeChar) {
              this.$message({
                type: "error",
                message: "不能含有特殊字符&",
              });
              return;
            }
            console.log("回答完全");
            if (res.answers.length) {
              let parmas = {
                mediationId: this.$route.query.meetingid,
                userType: this.memberType,
                answerList: res.answers,
              };
              console.log("请求参数", parmas);
              usersubmitAnswersApi(parmas)
                .then((res) => {
                  console.log(res);
                  // store中存值
                  setStore("hasSubmitQuesListSuccessFlag", true);
                  // 刷新页面
                  if (res.data.code === 1000) {
                    this.$message.success("提交成功");
                    this.$confirm(
                      "庭审结束前若需更改回答内容，请联系案件办理人员。",
                      "温馨提示",
                      {
                        distinguishCancelAndClose: true,
                        confirmButtonText: "确定",
                      }
                    ).then(() => {
                      this.$emit("reloadData");
                    });
                  } else {
                    this.$message.error(res.data.message);
                  }
                })
                .catch((err) => {
                  console.log(err);
                  // this.$message.error('发生未知错误，提交失败')
                });
            } else {
              setStore("hasSubmitQuesListSuccessFlag", true);
              this.$message.warning("暂无需要回答的问题");
            }
          } else {
            // 弹框提示
            this.$alert(
              "您有未完成的问题单，请完成后统一提交，提交后无法修改。",
              "提示",
              {
                confirmButtonText: "确定",
              }
            ).then(() => {
              this.scrollToTargetQuestion(res.firstUnCompleteQuestionId);
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 检验回答的正确性
    checkAnswerCorrect() {
      let that = this;
      return new Promise((resolve, reject) => {
        // 整合数据
        // let allQuestion = [].concat(this.questions);
        // allQuestion = allQuestion.concat(this.finalStatements);
        let answers = [];
        let count = 0;
        let failCount = 0;
        let firstUnCompleteQuestionId = "";
        this.questions.map((item, index) => {
          this.$refs.answerForm[index]
            .getCurrentForm()
            .then((res) => {
              // 处于不能编辑的状态
              console.log("单个问题", item);
              if (item.userAnswerRes && item.userAnswerRes.submitStatus !== 2) {
                answers.push({
                  questionId: item.id,
                  answerContent: res,
                });
              }
            })
            .catch((err) => {
              if (err == "系统暂不支持emoji表情") {
                that.hasEmoji = true;
              } else if (err == "含有特殊符号") {
                console.log("jijiji--");
                that.hasSpeChar = true;
              } else {
                console.log("duoduoduo--");
                if (failCount === 0) firstUnCompleteQuestionId = item.id; //取第一个未回答问题id  方便后面滚动
                failCount++;
                console.log("failCount", failCount, err);
              }
            })
            .finally((_) => {
              count++;
              console.log("complete", count);
              if (count === this.questions.length) {
                console.log("完成", answers);
                let res = {
                  answers: answers,
                };
                console.log("failCount", failCount);
                if (failCount) {
                  // 没有回答完全
                  res.flag = false;
                  res.firstUnCompleteQuestionId = firstUnCompleteQuestionId;
                } else {
                  // 回答完全
                  res.flag = true;
                }
                resolve(res);
              }
            });
        });
      });
    },
    // 调解员答案转化
    convertAnswerForMediator(jsonString) {
      let object = JSON.parse(jsonString);
      // console.log(object)
      return object.text;
    },
    scrollToTargetQuestion(idString) {
      console.log(idString);
      this.isGuideDidClick2scroll = true;
      document.getElementById(idString).scrollIntoView();
      setTimeout(() => (this.isGuideDidClick2scroll = false), 500);
    },
    convertUserTypeName(memberType) {
      let userTypeName = "";
      if (memberType === "APPLICANT") {
        userTypeName = "申请人";
      } else if (memberType === "APPLICANT_AGENT") {
        userTypeName = "申请人代理人";
      } else if (memberType === "RESPONDENT") {
        userTypeName = "被申请人";
      } else if (memberType === "RESPONDENT_AGENT") {
        userTypeName = "被申请人代理人";
      }
      return userTypeName;
    },
    onListScroll(e) {
      if (this.isGuideDidClick2scroll) return;
      this.questions.forEach((qq, index) => {
        if (document.getElementById(qq.id).getBoundingClientRect().top < 250) {
          this.$emit("changeGuideChecked", index + 1);
        }
      });
    },
    coverClick() {
      this.$message({
        type: "error",
        message: "申请人未回答完毕",
      });
    },
    // 一键保存所有问题
    saveAllQuestion() {
      console.log("inventory一键保存", this.questions);
      let answers = [];
      this.questions.map((item, index) => {
        this.$refs.answerForm[index].getCurrentForm1().then((res) => {
          answers.push({
            questionId: item.id,
            answerContent: res,
          });
        });
      });
      let parmas = {
        mediationId: this.$route.query.meetingid,
        userType: this.memberType,
        answerList: answers,
      };
      console.log("入参----", parmas);
      saveAllQuestionAnswer(parmas)
        .then((res) => {
          console.log("一键保存res----", res);
        })
        .catch((err) => {
          console.log("一键保存err----", err);
        });
    },
  },
};
</script>

<style lang="scss"  >
.inventory {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  margin-bottom: 25px;
  overflow: scroll;

  .section-header {
    height: 80px;
    flex-shrink: 0;
    background: #edf5fe;
    display: flex;
    flex-direction: row;
    align-items: center;

    .verticalLine {
      margin-left: 40px;
      width: 4px;
      height: 20px;
      background: #1e6dcb;
    }

    .title {
      margin-left: 10px;
      font-size: 20px;
      color: #333;
    }

    .el-button {
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  .content {
    padding-right: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    background: #f5faff;
    overflow: auto;

    .question-view {
      display: flex;
      flex-direction: column;

      .question {
        margin-top: 25px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .icon {
          // background: red;
          margin-left: 40px;
          width: 24px;
          height: 24px;
        }

        .title {
          flex: 1;
          font-size: 18px;
          color: #333;
          margin-left: 5px;
        }
      }

      .answer-status {
        margin-top: 20px;
        margin-left: 40px;
        display: flex;
        flex-direction: row;

        .litigant {
          flex: 1;
          display: flex;
          flex-direction: row;

          .title {
            margin-top: 7px; // min-width: 120px;
          }

          .members {
            margin-left: 10px;
            position: relative;

            .member {
              margin-right: 20px;
              margin-bottom: 10px;

              .icon {
                margin-right: 1px;
              }

              .buttonDelete {
                position: absolute;
                color: black;
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }

      .answer-view {
        margin-left: 40px;

        .answer {
          border: 1px solid #e0eefe;
          background: #f3f8ff;
          display: flex;
          flex-direction: column;
          align-items: stretch;
          color: #333333;
          font-size: 16px;

          .name-type {
            padding: 10px;
          }

          .content {
            word-break: break-all;
            padding: 10px;
          }
        }
      }
    }
  }

  .el-card__body {
    padding: 0;
  }

  .answerListCover {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
    left: 0;
    top: 0;
  }
  .el-dialog__header{
    border-bottom: 1px solid #DCDCDC;
  }

  .dialogContainer {
    display: flex;
    //line-height: 40px;
    margin-right: 10px;
    font-size: 16px;
    color: #333333;
    
    .dialogContent {
      width: 100px;
      height: 20px;
      line-height: 40px;
    }
    .uploadContent {
      flex: 1;
     .el-upload-dragger{
        width: 100%;
        height: 100%;
        border: none;
       // border-radius: 1px;
      }
      .warn{
        margin-top: 10px;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #606266;
        margin-bottom: 10px;
      }
      .el-btn-upload{
        width: 100px;
        font-size: 14px;
        border: 1px solid #006CD2;
        height: 36px;
        line-height: 36px;
        color: #1E6DCB;
        text-align: center;
      }
      .excelTemplate{
        width: 120px;
         font-size: 14px;
        text-align: left;
        color: #006CD2;
      }
      .el-upload-list__item{
        margin-top: 6px;
        font-size: 14px;
        background-color: #EFEFEF;
      }
    }
  }
  .dialog-footer{
    .confirm_ca{
        border-radius: 0;
        border: 1px solid  #1E6DCB;
        color: #1E6DCB;
    }
    .confirm_re{
        margin-left:20px;
        border-radius: 0;
        background: #1E6DCB;
        color: #fff;
    }
  }
}
</style>
